import AdditionalAppsMessage from './AdditionalAppsMessage';

export type { AdditionalAppsMessageProps } from './types';
export default AdditionalAppsMessage;
